import { type CheckboxProps, Checkbox as MuiCheckbox, Stack, type SxProps } from '@mui/material';
import { type ReactNode, useId } from 'react';

import Text from '../Text';

interface Props extends CheckboxProps {
  label?: ReactNode;
  sx?: SxProps;
}

export default function Checkbox({ label, ...props }: Props) {
  const id = useId();

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'center',
      }}
    >
      <MuiCheckbox
        color="secondary"
        {...props}
        id={id}
      />
      {label && (
        <label htmlFor={id}>
          {typeof label === 'string' ? <Text size="small">{label}</Text> : label}
        </label>
      )}
    </Stack>
  );
}
